export function flatToTree(inlist, inIndex, inStartLevel, inTree) {
  // set defaults
  const list = inlist || [];
  const level = inStartLevel || 0;
  const tree = inTree || [];
  let index = inIndex || 0;

  for (let i = index; i < list.length; i++) {
    const currentItem = list[i];

    // if the level decreases
    if (currentItem.level < level) {
      index = i - 1;
      break;
    }

    // add item if right level
    if (currentItem.level === level) {
      tree.push({
        level: currentItem.level,
        text: currentItem.text,
        id: currentItem.id,
        children: [],
      });
    }

    // if level increases we need to append the children
    if (currentItem.level > level) {
      const children = flatToTree(list, i, level + 1, []);
      i = children.index;
      if (!tree.length) {
        tree.push({ children: [] });
      }

      // append children we get from the routine
      tree[tree.length - 1].children.push(...children.tree);
    }
    index = i;
  }
  return {
    tree,
    index,
  };
}
